import type { HelpFile } from '../../types/help'
import { IdentityLifecycleHeaderTestIds } from '../../../testids/IdentityLifecycleHeaderTestIds'

export const identityLifecycleHeaderHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderSummary]:
      'Above-the-fold summary of the most recent identity lifecycle event — state pair, trigger source, actor, timestamp, and truncated reason.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderFromState]:
      'Previous lifecycle state before this transition. Hidden for the initial creation row.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderToState]:
      'New lifecycle state after this transition. For the initial row this shows "Created as <state>" because there is no fromState.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderTriggerSource]:
      'Which business process drove the change (USER_ACTION, JML_LEAVER, EXIT_DATE_JOB, etc.).',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderActor]:
      'The human actor who performed the change. System-driven transitions show "System" with the triggering process noted in the trigger source.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderTimestamp]:
      'Relative time of the transition. Hover for the absolute timestamp.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderReason]:
      'Free-text reason captured at transition time. Truncated at 80 chars; hover to see the full text.',
    [IdentityLifecycleHeaderTestIds.lifecycleHeaderViewTimeline]:
      'Open the full identity lifecycle timeline tab to see all state changes for this identity.',
  },
}
